import { render, staticRenderFns } from "./QuestionThemeSelector.vue?vue&type=template&id=2e749312"
import script from "./QuestionThemeSelector.vue?vue&type=script&lang=js"
export * from "./QuestionThemeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e749312')) {
      api.createRecord('2e749312', component.options)
    } else {
      api.reload('2e749312', component.options)
    }
    module.hot.accept("./QuestionThemeSelector.vue?vue&type=template&id=2e749312", function () {
      api.rerender('2e749312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionThemeSelector.vue"
export default component.exports